import template from "./bin_manifest.html";
import controller from "./bin_manifest.controller";
import "./bin_manifest.scss";

let branchManagementBinManifestComponent = {
  restrict: "E",
  bindings: {},
  template,
  controller
};

export default branchManagementBinManifestComponent; 



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/bin_manifest/bin_manifest.component.js